import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TokenService } from 'src/app/shared/service/token.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-role-list',
  templateUrl: './role-list.component.html',
  styleUrls: ['./role-list.component.scss']
})
export class RoleListComponent implements OnInit {

  public menus = [];
  public selected = [];
  RoleList;
  isLoading;
  isDeleting;
  DeletingItem;

  constructor(private router: Router, private http: HttpClient, private toastr: ToastrService, private modalService: NgbModal,private TokenService: TokenService) {
    if (!this.TokenService.getUser().IsAdmin) {
      router.navigateByUrl('/');
    }
  }


  ngOnInit() {
    this.GetRoleList();
  }

  GetRoleList() {
    this.http.get<any>(environment.url + 'Roles/GetRoles').subscribe(data => {
      this.RoleList = data;
      this.isLoading = true;
    });
  }

  DeleteRole() {
    this.isDeleting = true;
    var body = { Ref: this.DeletingItem };
    this.http.post<any>(environment.url + 'Roles/DeleteRole', body).subscribe(data => {
      this.isDeleting = false;
      this.DeletingItem = "";
      this.GetRoleList();
      if (!data.Error) {
        this.modalService.dismissAll();
        this.toastr.success("Rol Silindi", '', {
          timeOut: 3000,
        });
      }
      else {
        this.toastr.error("Rol Silinemedi", 'Hata !', {
          timeOut: 3000,
        });
      }
    });
  }

  gotoRoleEdit(item: any) {
    const navigatioExtra: NavigationExtras = {
      queryParams: { id: item }
    }
    this.router.navigate(['/home/definitions/edit-role'], navigatioExtra);
  }
  DeleteRoleModal(file,ref) {
    this.DeletingItem = ref;
    this.modalService.open(file, { centered: true });
  }
  CloseDeleteModalClose(){
    this.modalService.dismissAll();
    this.DeletingItem = "";
  }

}
